<template>
	<div class="login-container">
		<div class="logo-wrapper">
			<img src="./logo.png" width="100%" height="100%" />
		</div>
		<h3 class="login-text">
			请登录以便获取您的风险报告~
		</h3>
		<div class="content">
			<div class="input-wrapper">
				<input
					type="tel"
					class="input txr-asterisk"
					placeholder="请输入手机号"
					v-model.trim="mobile"
					:disabled="propMobile"
				/>
			</div>
			<div class="input-wrapper code" v-if="sit">
				<input
					type="text"
					class="input"
					placeholder="请输入图形码"
					v-model.trim="imgCode"
				/>
				<div class="img-code-wrapper" @click="getImgCode">
					<img :src="imgData" v-if="imgData" width="100%" height="100%" />
				</div>
			</div>
			<div class="input-wrapper code" v-if="sit">
				<input
					type="tel"
					class="input txr-asterisk"
					placeholder="请输入验证码"
					v-model.trim="smsCode"
				/>
				<div
					class="code-wrapper"
					:class="{ actived: actived }"
					@click="sendCode"
				>
					{{ smsText }}
				</div>
			</div>
			<a
				href="javascript:;"
				class="submit"
				:class="{ active: mobile && smsCode }"
				@click="submit"
				>登录</a
			>
		</div>
	</div>
</template>
<script>
import qs from 'qs';
const url = qs.parse(window.location.search.slice(1));
export default {
	props: {
		login: {
			type: Function,
			required: true,
		},
		action: {
			type: String,
			required: true,
		},
		propMobile: {
			type: String,
		},
	},
	data() {
		let mobile = '';
		this.propMobile && (mobile = this.propMobile);
		return {
			imgData: '',
			imgCode: '',
			mobile,
			tcode: '',
			ucode: '',
			smsCode: '',
			count: -1,
			path: '',
		};
	},
	computed: {
		smsText() {
			return this.count == -1 ? '点击发送' : `重新发送${this.count}s`;
		},
		actived() {
			return this.count == -1 && this.mobile && this.imgCode;
		},
		sit() {
			return true;
			// return (
			// 	window.location.origin.indexOf('https://hms-uat.test-cignacmb.com') ==
			// 	-1
			// );
		},
	},
	created() {
		url.path && (this.path = url.path);
		this.getImgCode();
	},
	methods: {
		getImgCode() {
			this.$http({
				loading: true,
				url: '/bdzb-permission/usr/buildRandomGraphic',
				data: { action: this.action, rcode: 1603264224899 },
				method: 'POST',
			}).then((data) => {
				const respData = data.respData;
				this.imgData = respData.hurl;
				this.tcode = respData.tcode;
				this.ucode = respData.ucode;
			});
		},
		sendCode() {
			if (!this.actived) return;
			if (!/^\d+$/.test(this.mobile)) {
				this.$toast('手机号码格式不正确');
				return;
			}
			this.$http({
				loading: true,
				url: '/bdzb-permission/usr/sendSms',
				data: {
					action: this.action,
					imgCode: this.imgCode,
					ucode: this.ucode,
					tcode: this.tcode,
					mobile: this.mobile,
				},
				method: 'POST',
			}).then((data) => {
				const respCode = data.respCode;
				if (respCode == '00') {
					this.timeCount();
				} else {
					this.$toast(data.respDesc);
				}
			});
		},
		timeCount() {
			this.count = 60;
			let timer = setInterval(() => {
				this.count--;
				if (this.count == -1) {
					clearInterval(timer);
				}
			}, 1000);
		},
		submit() {
			if (this.mobile == '') {
				this.$toast('请输入手机号码');
				return;
			}
			if (!/^\d+$/.test(this.mobile)) {
				this.$toast('手机号码格式不正确');
				return;
			}
			if (this.smsCode == '' && this.sit) {
				this.$toast('请输入短信验证码');
				return;
			}
			this.login({
				action: this.action,
				smsCode: this.smsCode,
				version: 'bd_336',
				mobile: this.mobile,
			});
		},
	},
};
</script>

<style scoped>
.login-container {
	width: 100vw;
	background-image: url(./login-bg.png);
	background-size: cover;
	background-repeat: no-repeat;
	overflow: hidden;
}
.logo-wrapper {
	width: 1.19rem;
	height: 0.34rem;
	margin-top: 0.25rem;
	margin-left: 0.34rem;
}
.login-text {
	font-size: 0.17rem;
	color: #0f2742;
	padding: 0.23rem 0.34rem;
}
.content {
	padding: 0 0.34rem;
}
.input-wrapper {
	position: relative;
	height: 0.46rem;
	padding-right: 0.12rem;
	margin-bottom: 0.17rem;
	font-size: 0.12rem;
	color: #797979;
	border-bottom: 1px solid #e8ecf1;
}
.input-wrapper .input {
	box-sizing: border-box;
	width: 100%;
	height: 0.46rem;
	padding: 0.12rem 0;
	outline: none;
	border: none;
	color: #797979;
	background: transparent;
}
.input-wrapper .input:focus,
.input-wrapper .input:focus + .text {
	color: #0f2742;
}
.img-code-wrapper {
	position: absolute;
	right: 0.03rem;
	top: 0.06rem;
	bottom: 0.06rem;
	width: 0.7rem;
	background: #fff;
}
.input-wrapper .code-wrapper {
	position: absolute;
	right: 0;
	top: 50%;
	transform: translateY(-50%);
	width: 0.7rem;
	height: 0.23rem;
	line-height: 0.23rem;
	font-size: 0.11rem;
	text-align: center;
	border: 1px solid #3b97ff;
	border-radius: 0.15rem;
	color: #3b97ff;
	opacity: 0.4;
}
.input-wrapper .code-wrapper.actived {
	opacity: 1;
}
.submit {
	display: block;
	height: 0.37rem;
	line-height: 0.37rem;
	margin-top: 0.79rem;
	font-size: 0.14rem;
	text-align: center;
	font-weight: bold;
	color: #fff;
	background: #3b97ff;
	border-radius: 0.19rem;
	opacity: 0.4;
}
.submit.active {
	opacity: 1;
}
.submit:actived {
	opacity: 0.7;
}
</style>
